import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { IParsedSettingsFromQBRDocumentsListItem } from 'partner360/models/qbr/IParsedSettingsFromQBRDocumentsListItem'
import { IQBRDocumentDetail } from 'partner360/models/qbr/IQBRDocumentDetail'

import { IFetchQbrDocumentResponse } from '../../../models/qbr/IFetchQbrDocumentResponse'

export interface IApplyChanges {
  entryId: number | null
  partners: string[]
  document?: IQBRDocumentDetail | null
  settings?: IParsedSettingsFromQBRDocumentsListItem
  rtm: string
  name?: string | null
  isLegacyDocument?: boolean
  isNoGenerate?: boolean
  isFinalized?: boolean
  globalPartnerId?: string | null
}

export const applyChanges = async ({
  entryId,
  partners,
  document,
  settings,
  rtm,
  name,
  isLegacyDocument,
  isNoGenerate,
  isFinalized = false,
  globalPartnerId,
}: IApplyChanges): Promise<{ Data: IFetchQbrDocumentResponse[] }> => {
  const url = proxy('/webservice/197/sp/v4/spJBPQBRDocumentApplyChanges/call')

  const {
    app: { ownerId },
  } = appGetState()

  const [accessToken] = getTokens(ownerId)

  const payload = {
    'p.EntryId': entryId,
    'p.Partners': JSON.stringify(partners),
    'p.DocumentJSON': document ? JSON.stringify(document) : null,
    'p.Settings': settings ? JSON.stringify(settings) : null,
    'p.RTM': rtm,
    'p.Name': name,
    'p.IsLegacyDocument': isLegacyDocument ? 1 : 0,
    'p.IsNoGenerate': isNoGenerate ? 1 : 0,
    'p.Finalized': Number(isFinalized),
    'p.GlobalPartnerId': globalPartnerId || null,
  }

  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const response = await Rest.post({ url, payload, headers })
  if (response && response.Data) {
    return { Data: response.Data }
  }

  return { Data: [] }
}
